import state from './enforcement.state'
import mutations from './enforcement.mutations'
import actions from './enforcement.actions'
import getters from './enforcement.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
